import { DataTableValue } from 'primereact/datatable';
import { Dataset } from '../../../../types/types';
import { getStyleClassNames } from '../../../../utils/getStyleClassNames';

export const getRowStyleClassNames = (
  rowData: DataTableValue,
  dataset: Dataset
): string => {
  const styleItem = dataset.styleItem;
  if (!styleItem) return '';

  const raw = rowData[styleItem];
  return getStyleClassNames(
    typeof raw === 'string' ? raw : undefined,
    dataset.datasetId
  );
};
